import { createContext, useContext } from 'react';

/**
 * Opens the "Get the app" QR modal. `null` when rendered outside the provider
 * (e.g. in isolation), in which case triggers fall back to normal navigation.
 */
export const AppModalContext = createContext<(() => void) | null>(null);

export function useOpenAppModal() {
  return useContext(AppModalContext);
}
